var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{attrs:{"isJobs":_vm.isJobs},on:{"update:isJobs":function($event){_vm.isJobs=$event},"update:is-jobs":function($event){_vm.isJobs=$event}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }